import React from "react";
import './sidebar.scss';
import RecordAdjustment from "./RecordAdjustment";
import RecordAdjustmentManager from "./RecordAdjustmentManager";
import { useSidebarData } from "../../hooks/sidebarData";
import DTRApproval from "./DTRApproval";
import LeaveApproval from "./leave/LeaveApproval";
import LeaveDetails from "./leave/LeaveDetails";
import EventDetails from "./EventDetails";
import NDOTDetails from "./ndot/NDOTDetails";
import NDOTApproval from "./ndot/NDOTApproval";


const Sidebar = () => {
    const { sidebarData, setSidebarData } = useSidebarData();

    // handler for closing sidebar
    const handleSidebarClosing = () => {
        setSidebarData('state', false);
        setSidebarData('key', '');
        setSidebarData('label', '');
        setSidebarData('data', []);
    }


    return (
        <div className={'sidebar' + (sidebarData?.state ? ' show' : ' hide')}>
            <div className="header">
                <h3>{sidebarData?.label}</h3>
                <button type="button" onClick={() => { handleSidebarClosing() }}>
                    <i className="fa fa-times"></i>
                </button>
            </div>

            <div className="content">
                <>{
                    sidebarData?.key === 'record-adjustment'
                        ? <RecordAdjustment />
                        : sidebarData?.key === 'manager-record-adjustment'
                            ? <RecordAdjustmentManager />
                            : sidebarData?.key === 'dtr-approval'
                                ? <DTRApproval /> 
                                : sidebarData?.key === 'leave-request'
                                    ? <LeaveDetails />
                                    : sidebarData?.key === 'leave-request-status'
                                        ? <LeaveApproval />
                                        : sidebarData?.key === 'event'
                                            ? <EventDetails />
                                            : sidebarData?.key === 'ndot-request'
                                            ? <NDOTDetails />
                                            : sidebarData?.key === 'ndot-request-status'
                                            ? <NDOTApproval />
                                            : null
                }</>
                
            </div>
        </div>
    )
}

export default Sidebar;